const dev = {
  API_ENDPOINT: 'http://localhost:5000/v1/',
  API_ENDPOINT_V2: 'http://localhost:5000/v2/',
  PORTAL_API_ENDPOINT: 'http://localhost:5000/portal/',
};

const prod = {
  API_ENDPOINT: 'https://mtdigital.tamweel-aloula.sa/v1/',
  API_ENDPOINT_V2: 'https://mtdigital.tamweel-aloula.sa/v2/',
  PORTAL_API_ENDPOINT: 'https://mtdigital.tamweel-aloula.sa/portal/',
};

const test = {
  API_ENDPOINT: 'https://api-mob-stg.tamweel-aloula.sa/v1/',
  API_ENDPOINT_V2: 'https://api-mob-stg.tamweel-aloula.sa/v2/',
  PORTAL_API_ENDPOINT: 'https://api-mob-stg.tamweel-aloula.sa/portal/',
};

const uat = {
  API_ENDPOINT: 'https://api-mob-stg.tamweel-aloula.sa/v1/',
  API_ENDPOINT_V2: 'https://api-mob-stg.tamweel-aloula.sa/v2/',
  PORTAL_API_ENDPOINT: 'https://api-mob-stg.tamweel-aloula.sa/portal/',
};

const sit = {
  API_ENDPOINT: 'https://api-mob-sit.tamweel-aloula.com/v1/',
  API_ENDPOINT_V2: 'https://api-mob-sit.tamweel-aloula.com/v2/',
  PORTAL_API_ENDPOINT: 'https://api-mob-sit.tamweel-aloula.com/portal/',
};

//console.log("process.env.REACT_APP_NODE_ENV",process.env.REACT_APP_NODE_ENV);
//console.log("process.env.NODE_ENV",process.env.NODE_ENV);
const getEnvironment = () => {
  switch (process.env.REACT_APP_NODE_ENV) {
  // switch ('uat') {
    case 'development':
      return dev;
    case 'production':
      return prod;
    case 'test':
      return test;
    case 'uat':
      return uat;
    case 'sit':
      return sit;
    default:
      return dev;
  }
};

const env = getEnvironment();

export default env;
